<template>
  <div class="EventModalBlock">
    <transition name="fade">
      <div v-show="isOpen" class="EventModal">
        <div class="EventModal__background"></div>
        <div class="EventModal__popup">
          <button class="EventModal__close" @click="toggleModal">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.6347 3.55898C15.1972 2.97305 15.1972 2.02148 14.6347 1.43555C14.0722 0.849609 13.1587 0.849609 12.5962 1.43555L7.85767 6.37617L3.11467 1.44023C2.55217 0.854297 1.63867 0.854297 1.07617 1.44023C0.513672 2.02617 0.513672 2.97773 1.07617 3.56367L5.81917 8.49961L1.08067 13.4402C0.518172 14.0262 0.518172 14.9777 1.08067 15.5637C1.64317 16.1496 2.55667 16.1496 3.11917 15.5637L7.85767 10.623L12.6007 15.559C13.1632 16.1449 14.0767 16.1449 14.6392 15.559C15.2017 14.973 15.2017 14.0215 14.6392 13.4355L9.89617 8.49961L14.6347 3.55898Z"
                fill="white"
              />
            </svg>
          </button>
          <div v-if="event" class="EventModal__content">
            <div
              class="EventModal__image"
              :style="{
                backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.5) 10%, rgba(0, 0, 0, 0) 100%), url(${event.image})`,
              }"
            >
              <div class="EventModal__category">
                {{ event.tags.category[0].title }}
              </div>
              <h2 class="EventModal__title">
                {{ event.title }}
              </h2>
            </div>
            <div class="EventModal__details">
              <div class="EventModal__text">
                {{ trimmedLead }}
                <a
                  v-if="!isDesktop()"
                  :href="event.fullPath"
                  class="EventModal__trimmed-link"
                  >Läs mer</a
                >
              </div>
              <div class="EventModal__info">
                <EventModalTags
                  v-if="event.duration"
                  :tag-label="translations.duration"
                  :tags="[{ title: event.duration }]"
                />
                <EventModalTags
                  v-if="event.tags.location.length"
                  :tag-label="translations.location"
                  :tags="event.tags.location"
                />
                <EventModalTags
                  v-if="event.tags.targetAudience.length"
                  :tag-label="translations.targetAudience"
                  :tags="event.tags.targetAudience"
                />
                <EventModalTags
                  v-if="event.tags.accessibility.length"
                  :tag-label="translations.accessibility"
                  :tags="event.tags.accessibility"
                />
              </div>
            </div>
          </div>
          <div v-else>
            <div class="EventModal__image"></div>
            <div class="EventModal__details">
              <div class="EventModal__text">
                <SkeletonBox
                  v-for="number in isDesktop() ? 6 : 3"
                  :key="number"
                  height="10px"
                  width="100%"
                  margin="12px"
                />
                <SkeletonBox height="10px" width="90%" margin="1rem" />
              </div>
              <div class="EventModal__info">
                <div v-for="number in 4" :key="number">
                  <SkeletonBox height="10px" width="50px" margin="5px" />
                  <SkeletonBox height="10px" width="100px" margin="1rem" />
                </div>
              </div>
            </div>
          </div>
          <TicketBlock
            :event-nid="eventNid"
            :in-hero="false"
            class="EventModal__tickets"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TicketBlock from "../ticket_block/TicketBlock.vue";
import SkeletonBox from "../../vue_components/SkeletonBox/SkeletonBox.vue";
import EventModalTags from "./components/Tags.vue";

export default {
  name: "EventModalBlock",
  components: { EventModalTags, SkeletonBox, TicketBlock },
  data() {
    return {
      translations: {
        tickets: Drupal.t("Tickets"),
        location: Drupal.t("Location"),
        date: Drupal.t("Date"),
        duration: Drupal.t("Duration"),
        targetAudience: Drupal.t("Target Audience"),
        accessibility: Drupal.t("Accessibility"),
      },
      eventNid: null,
      isOpen: false,
    };
  },
  created() {
    document.addEventListener("click", (e) => {
      let modalLink = e.target.closest("a.event-modal");
      if (modalLink) {
        e.preventDefault();
        this.setEventNid(modalLink.getAttribute("data-event-nid"));
        this.toggleModal();
        document.addEventListener("keyup", this.closeOnEscape);
      }
    });
  },
  methods: {
    ...mapActions(["fetchEventData"]),
    setEventNid(nid) {
      this.eventNid = nid;
      this.fetchEventData(this.eventNid);
    },
    toggleModal() {
      this.isOpen = !this.isOpen;
      document.body.classList.toggle("EventModal--open");
    },
    closeOnEscape(e) {
      if (e.key === "Escape") {
        this.toggleModal();
        document.removeEventListener("keyup", this.closeOnEscape);
      }
    },
    isDesktop() {
      const mediaDesktop = window.matchMedia("(min-width: 976px)");
      return mediaDesktop.matches;
    },
  },
  computed: {
    ...mapGetters({
      eventData: "getEventData",
      loadingTickets: "getLoadingTicketsState",
    }),
    event() {
      return this.eventData[this.eventNid];
    },
    trimmedLead() {
      if (this.isDesktop()) {
        return this.event.lead;
      } else {
        return this.event.lead.length > 120
          ? `${this.event.lead.substring(0, 120)}...`
          : this.event.lead;
      }
    },
  },
};
</script>

<style lang="scss">
@import "web/themes/custom/khst_theme/_sass-config/sass-config";

.EventModal {
}

body.EventModal--open {
  height: 100vh;
  overflow-y: hidden;

  .page__top {
    z-index: -1;
    opacity: 0;
  }
  .swiper-wrapper,
  .swiper-container,
  .swiper-slide {
    z-index: -1;
    position: static;
  }
  .node--promo-large__content {
    z-index: 0;
  }
}

.EventModal__background {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 200;
  background: rgba(0, 0, 0, 0.9);
  scroll-behavior: unset;
}

.EventModal__close {
  border: none;
  background: black;
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 20;
  border-radius: 100%;
  padding: 4px 8px 3px;
}

.EventModal__popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95%;
  max-width: 950px;
  border-radius: 4px;
  background: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12), 0 4px 32px rgba(0, 0, 0, 0.28);
  z-index: 600;

  @include breakpoint($toolbar) {
    min-height: 300px;
  }
}

.EventModal__content {
}

.EventModal__image {
  background-size: cover;
  background-color: black;
  background-position: center;
  position: relative;
  padding: 2rem;
  height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @include breakpoint($toolbar) {
    height: 400px;
  }
}

.EventModal__details {
  padding: 1rem 2rem;
  background-color: $light-grey;

  @include breakpoint($phone-mini) {
    padding: 2rem;
  }
}

.EventModal__text {
  font-weight: 600;
  font-size: 14px;

  @include breakpoint($phone-mini) {
    font-size: 16px;
  }

  @include breakpoint($toolbar) {
    width: 50%;
    margin-bottom: 2rem;
  }
}

.EventModal__category {
  font-family: $neue-plak-wide;
  font-weight: 400;
  font-size: 16px;
  color: $white;
  line-height: 1;
  text-transform: uppercase;
}

.EventModal__title {
  font-family: $neue-plak-cond;
  font-size: 41px;
  font-weight: 900;
  line-height: 1;
  text-transform: uppercase;
  margin: 0;
  color: $white;

  @include breakpoint($toolbar) {
    width: 50%;
  }
}

.EventModal__tickets {
  box-shadow: none;

  @include breakpoint($toolbar) {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12), 0 4px 32px rgba(0, 0, 0, 0.28);
    position: absolute;
    right: 2rem;
    bottom: 100px;
    z-index: 40;
  }
}

.EventModal__info {
  display: none;
  font-family: $neue-plak;
  font-size: 14px;
  line-height: 21px;
  color: #616161;

  @include breakpoint($toolbar) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 50%;
  }
}

.EventModal__trimmed-link {
  color: $grey;
  text-decoration: none;
}

.EventModal__tags {
  margin-bottom: 1rem;
}

.EventModal__tagLabel {
  font-weight: 700;
  text-transform: uppercase;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
